module.exports = __webpack_public_path__ + "static/img/education_system_3_1.0d7e1ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/education_system/education_system_3_1.jpg
// module id = Lmi6
// module chunks = 1